import React from 'react';
import styles from './WhatsAppButton.module.css';

function WhatsAppButton({ forceShow, isMobileMenuOpen }) {
    // Exibe se estiver forçado (ex: página de dados) OU se o menu mobile estiver aberto
    if (!forceShow && !isMobileMenuOpen) {
        return null;
    }

    const phoneNumber = '5531999075682'; // Insira o seu número com DDD
    const message = encodeURIComponent('Olá! Vim pelo sistema ReproBird e gostaria de tirar uma dúvida.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <a 
            href={whatsappUrl} 
            className={styles.whatsapp_float} 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Contato via WhatsApp"
        >
            <svg viewBox="0 0 32 32" className={styles.whatsapp_icon}>
                <path d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 8.138-2.135c2.35 1.325 5.038 2.135 7.863 2.135 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.333c-2.488 0-4.913-0.675-7.037-1.95l-0.5-0.3-5.225 1.37 1.39-5.183-0.33-0.525c-1.393-2.222-2.131-4.788-2.131-7.412 0-7.625 6.208-13.833 13.833-13.833s13.833 6.208 13.833 13.833c0 7.625-6.208 13.833-13.833 13.833zM22.583 19.342c-0.362-0.181-2.141-1.057-2.472-1.178s-0.573-0.181-0.814 0.181c-0.241 0.362-0.934 1.178-1.145 1.419s-0.422 0.271-0.784 0.091c-0.362-0.181-1.53-0.564-2.915-1.799-1.077-0.961-1.805-2.148-2.016-2.51s-0.022-0.558 0.158-0.738c0.163-0.163 0.362-0.422 0.543-0.633s0.241-0.362 0.362-0.603c0.121-0.241 0.06-0.452-0.030-0.633s-0.814-1.962-1.115-2.686c-0.293-0.706-0.592-0.611-0.814-0.622s-0.452-0.011-0.693-0.011c-0.241 0-0.633 0.091-0.964 0.452s-1.265 1.236-1.265 3.013c0 1.777 1.295 3.494 1.476 3.735s2.551 3.896 6.18 5.464c0.863 0.373 1.536 0.596 2.061 0.763 0.867 0.276 1.656 0.237 2.28 0.144 0.696-0.104 2.141-0.874 2.442-1.718s0.301-1.566 0.211-1.718c-0.091-0.151-0.331-0.241-0.693-0.422z" fill="#ffffff"/>
            </svg>
        </a>
    );
}

export default WhatsAppButton;